import { useContext } from 'react';
import { styled } from "@mui/material";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Button from "../../../../customs/Button";
import { NotificationContext } from '../../../../providers/notification';
import apiCall from '../../../../utils/apiCall';

interface ComponentProps {
    stateName: string;
    countryId: number;
    stateId: number;
    handleClose: () => void;
}

const DeleteState: React.FC<ComponentProps> = ({ stateName, handleClose, stateId, countryId }) => {
    const queryClient = useQueryClient();
    const { showNotification } = useContext(NotificationContext);

    const deleteState = (state: {stateId: number, countryId: number}) => {
        return apiCall().delete(`/State/DelState/${state?.countryId}/${state?.stateId}`);
    };

    const deleteStateMutation = useMutation(['delete-country'], deleteState, {retry: 0});

    const deleteStateHandler = async (state: {stateId: number, countryId: number}) => {

        try { 
            await deleteStateMutation.mutateAsync({stateId: state?.stateId, countryId: state?.countryId}, {
                onSuccess: () => {
                    showNotification({
                        message: 'State successfully disabled',
                        type: 'success'
                    })
                    queryClient.refetchQueries(['get-states']);
                    handleClose();
                }
            })
        } catch (error: any) {
            showNotification({
                message: error?.response?.data?.title || error?.message,
                type: 'error',
            })
        }
    };

    return (
        <StyledContainer>
            <StyledText>You are about to delete <strong>{stateName}</strong></StyledText>
            <ButtonWrapper>
                <ButtonContainer>
                    <StyledButton onClick={handleClose} text='Cancel'/>
                    <StyledButton 
                        type="submit" 
                        text={deleteStateMutation.isLoading ? 'Deleting...' : 'Yes, Delete'} 
                        onClick={() => deleteStateHandler({stateId, countryId})}
                        disabled={deleteStateMutation.isLoading}
                    />
                </ButtonContainer>
            </ButtonWrapper>
        </StyledContainer>
    )
}

export default DeleteState;

const StyledContainer = styled('div')`
    margin-inline: 3.5rem;
    margin-block: 2.5rem;
`

const ButtonWrapper = styled('div')`
    display: flex;
    justify-content: flex-end;
    margin-block: 2.5rem;
`

const ButtonContainer = styled('div')`
    display: flex;
    gap: 2rem;
`

const StyledButton = styled(Button)`
    padding-block: 1rem;
    padding-inline: 2rem;
    background-color: #DD5151;
`

const StyledText = styled('span')`
    color: #232323;
    font-size: 1.4rem;
    font-weight: 400;
`